export default {
  props: {
    breadcrumbList: {
      required: true
    }
  },

  computed: {
    breadcrumbListLength() {
      return this.breadcrumbList.length
    }
  },

  methods: {
    isLast(index) {
      return index === this.breadcrumbListLength - 1
    }
  }
}
